































import { Forbidden } from '@/api/responses/forbidden';
import { TargetTrackerApi } from '@/api/target-tracker';
import { TargetTrackerAppointmentPayment } from '@/shared/target-tracker-appointment-payment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const usersModule = namespace('users');

const targetTrackerApi = new TargetTrackerApi();

@Component
export default class TargetTrackerAssignAdvisorDialog extends Vue {
    @usersModule.Getter('activeLegalAdvisors') private legalAdvisors!: (partnerPracticeId: string) => string;
    @usersModule.Getter('fullName') private legalAdvisorName!: (userId: string) => string;

    @Prop({ required: true }) private value!: boolean;
    @Prop({ required: true }) private payment!: TargetTrackerAppointmentPayment;
    @Prop({ required: true }) private partnerPracticeId!: string;

    private isVisible: boolean = this.value;
    private isBusy: boolean = false;
    private legalAdvisorId: string | null = null;

    @Watch('value')
    private onValueChanged(value: boolean): void {
        this.isVisible = value;
    }

    private async onAssignAsync(): Promise<void> {
        try {
            this.isBusy = true;

            await targetTrackerApi.updateTargetTrackerPaymentOwnerAsync(this.payment.id, {
                legalAdvisorId: this.legalAdvisorId!,
                version: this.payment.version,
            });

            this.$emit('ok', this.legalAdvisorName(this.legalAdvisorId!));
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: `forbidden` });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not assign legal advisor to appointment, please try again.', type: 'is-danger' });
            }
        }

        this.isBusy = false;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

}
